import React from 'react';
import GeneralGrid from './GeneralGrid';

const SelectionGrid = props => <GeneralGrid showAddButton {...props} />;

SelectionGrid.propTypes = {};

export default SelectionGrid;
